'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function FooterColumn({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex w-full flex-col items-start justify-start gap-6 text-white xl:min-w-max',
        className,
      )}
    >
      {children}
    </div>
  );
}
